import Navigation from 'components/shared/Navigation/Navigation'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { hideSidebar } from 'redux/navigation'
import {
  Container,
  Dimmer,
  Divider,
  Header,
  Icon,
  Menu,
  Segment,
  Sidebar,
} from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const { sidebarVisible } = state.navigation
  return { sidebarVisible }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      hideSidebar,
    },
    dispatch
  )
}

class SidebarAdmin extends React.Component {
  render() {
    const { children, sidebarVisible, hideSidebar } = this.props

    return (
      <Sidebar.Pushable as={Segment} basic>
        <Sidebar
          as={Menu}
          visible={sidebarVisible}
          animation="push"
          direction="left"
          className="fixed"
          vertical
          inverted
          size="large">
          <Navigation
            render="link"
            as="menuitem-sidebar"
            node="admin/dashboard"
            customProps={{ color: 'blue', onClick: () => hideSidebar() }}
          />
          <Navigation
            render="link"
            as="menuitem-sidebar"
            node="admin/todos"
            customProps={{ color: 'blue', onClick: () => hideSidebar() }}
          />

          <Divider horizontal inverted>
            Bestellungen
          </Divider>
          <Navigation
            render="link"
            as="menuitem-sidebar"
            node="admin/inbox/contact-requests"
            customProps={{ color: 'orange', onClick: () => hideSidebar() }}
          />
          <Navigation
            render="link"
            as="menuitem-sidebar"
            node="admin/inbox/orders"
            customProps={{ color: 'orange', onClick: () => hideSidebar() }}
          />
          <Navigation
            render="link"
            as="menuitem-sidebar"
            node="admin/inbox/order-requests"
            customProps={{ color: 'orange', onClick: () => hideSidebar() }}
          />

          <Divider horizontal inverted>
            Sortiment
          </Divider>
          <Navigation
            render="link"
            as="menuitem-sidebar"
            node="admin/products/product"
            customProps={{ color: 'red', onClick: () => hideSidebar() }}
          />
          <Navigation
            render="link"
            as="menuitem-sidebar"
            node="admin/products/categories"
            customProps={{ color: 'red', onClick: () => hideSidebar() }}
          />
          <Navigation
            render="link"
            as="menuitem-sidebar"
            node="admin/products/discounts"
            customProps={{ color: 'red', onClick: () => hideSidebar() }}
          />
          <Navigation
            render="link"
            as="menuitem-sidebar"
            node="admin/products/properties"
            customProps={{ color: 'red', onClick: () => hideSidebar() }}
          />

          <Divider horizontal inverted>
            Benutzer
          </Divider>
          <Navigation
            render="link"
            as="menuitem-sidebar"
            node="admin/accounts/users"
            customProps={{ color: 'green', onClick: () => hideSidebar() }}
          />
        </Sidebar>

        <Sidebar.Pusher dimmed={sidebarVisible} onClick={() => hideSidebar()}>
          <Segment basic id="content" className="hide-below-tablet show-print">
            {children}
          </Segment>
        </Sidebar.Pusher>
        <Dimmer active={true} className="hide-above-tablet hide-print">
          <Container className="padded">
            <Header as="h3" icon inverted>
              <Icon
                name="ban"
                color={config.semantic_ui.primary_color}
                style={{ opacity: '.75' }}
              />
              {I18n.t('admin.general.not_supported')}
            </Header>
          </Container>
        </Dimmer>
      </Sidebar.Pushable>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SidebarAdmin)



// WEBPACK FOOTER //
// ./src/components/admin/Navigation/SidebarAdmin.jsx